import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  catchErrorAndEvict,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { SETTINGS_MEMBERS_ROLES_QUERY } from '../../graphql';

@Injectable({ providedIn: 'root' })
export class SettingsMembersRolesService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getSettingsMembersRoles(): Observable<any> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_MEMBERS_ROLES_QUERY) ||
      'functionalRoleList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_MEMBERS_ROLES_QUERY,
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.functionalRoleList),
        catchErrorAndEvict(this.apollo, this.clientName, fieldName),
      );
  }
}
